import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import AutoLogoutComponent from '../../AutoLogoutComponent'
import axios from 'axios'
import { UserWelcomeBanner } from '../UserWelcomeBanner'

function Header() {
  const rolename = capitalizeFirstLetter(localStorage.getItem('role'))
  const first_name = localStorage.getItem('first_name')
  const last_name = localStorage.getItem('last_name')
  const userid = localStorage.getItem('userid')
  const navigate = useNavigate()
  const [cookies, setCookie, removeCookie] = useCookies([])
  const [pstudents, setPStudents] = useState([])

  useEffect(() => {
    if (rolename && first_name && last_name) {
      // User is logged in
    } else {
      localStorage.removeItem('token')
      localStorage.removeItem('role')
      localStorage.removeItem('first_name')
      localStorage.removeItem('last_name')
      localStorage.removeItem('userid')
      navigate('/')
    }
    getParentStudents()
  }, [rolename, first_name, last_name])

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('role')
    localStorage.removeItem('first_name')
    localStorage.removeItem('last_name')
    localStorage.removeItem('userid')
    navigate('/')
  }

  function capitalizeFirstLetter(string) {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
  }

  const getParentStudents = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}get_students/${userid}`
      )
      setPStudents(response.data)
    } catch (error) {
      console.error('Error fetching tabs data:', error)
    }
  }

  // Sidebar logic removed from here

  return (
    <>
      <AutoLogoutComponent />
      <UserWelcomeBanner
        userName={`${first_name} ${last_name}${
          rolename && rolename !== 'Student' ? ` (${rolename})` : ''
        }`}
        welcomeMessage={
          rolename === 'Parent'
            ? `Welcome Parent / Guardian`
            : 'Welcome Back 👋'
        }
        avatarSrc={
          localStorage.getItem('profile_image') ||
          '/assets/images/graduating-student.png'
        }
        isOnline={true}
      />
    </>
  )
}

export default Header
